import React from 'react'
import "../../Styles/Shop.css"

const HeroSection2 = () => {
    return (

        <div className='pt-72 heroSection2 h-screen'>
            
        </div>
    )
}

export default HeroSection2